module.exports = __webpack_public_path__ + "img/aquarell_1920_1080_mit_wasserzeichen_21.4045192b.jpg";